import React from 'react'
import { Form as FinalForm } from 'react-final-form'

import { validate, handlePlanSubmit } from '@models/admin/plans'
import { RailsForm } from '@support/RailsForm'
import Form from './Form'

export const New = ({ model, handleError, statuses, o }) =>
  <RailsForm
    component={FinalForm}
    action='create'
    url={`/v4/o/${o}/store/admin/plans`}
    successUrl={`/v4/o/${o}/store/admin/plans`}
    initialValues={model}
    validate={validate}
    render={(props) => (
      <Form
        {...props}
        title={I18n.t('v4/plans.actions.add')}
        statuses={statuses}
        o={o}
      />
    )}
  />

export default New
